export const RESEND_MIN = 0.5;
export const RESPONSE_TYPE = ['token', 'id_token'];
export const SCOPES = ['openid', 'profile', 'lfs:identity:manage_credential', 'lfs:cards:apply', 'phone', 'email'];
